import React, { memo } from 'react'

import {
    formatCapacityDateFull,
    formatCapacityHours,
} from '../capacity.utils'
import styles from '../ProjectCapacityDashboard.module.css'

const CapacityTooltip = memo(({ segment, visible, x, y }) => {
    if (!visible || !segment) return null

    return (
        <div
            className={styles.capacityTooltip}
            style={{
                left: x,
                top: y,
            }}
            role="tooltip"
        >
            <div className={styles.tooltipRow}>
                <span className={styles.tooltipLabel}>Project</span>
                <span>{segment.projectName}</span>
            </div>
            <div className={styles.tooltipRow}>
                <span className={styles.tooltipLabel}>Task</span>
                <span>{segment.taskName}</span>
            </div>
            <div className={styles.tooltipRow}>
                <span className={styles.tooltipLabel}>Hours</span>
                <span>{formatCapacityHours(segment.totalHours)}</span>
            </div>
            <div className={styles.tooltipRow}>
                <span className={styles.tooltipLabel}>Start</span>
                <span>{formatCapacityDateFull(segment.startDate)}</span>
            </div>
            <div className={styles.tooltipRow}>
                <span className={styles.tooltipLabel}>End</span>
                <span>{formatCapacityDateFull(segment.endDate)}</span>
            </div>
        </div>
    )
})

CapacityTooltip.displayName = 'CapacityTooltip'

export default CapacityTooltip
